// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reconnect-loader[data-v-843d9344] {\n  background-color: var(--magic-tertiary, #311261);\n}\n\n.text[data-v-843d9344] {\n  color: var(--magic-light, #fff);\n}", ""]);
// Exports
module.exports = exports;
